import React, { useEffect, useState, useCallback } from 'react';
import { AlertContainer, DismissButton } from './styles';
import { AlertType } from './styles';

import { HiX } from 'react-icons/hi';

interface AlertProps {
  type?: AlertType;
  children: React.ReactNode;
  className?: string;
  dismissible?: boolean;
  onDismiss?: () => void;
  autoDismiss?: number;
}

export const Alert = ({
  type = 'info',
  children,
  className,
  dismissible = false,
  onDismiss,
  autoDismiss
}: AlertProps) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleDismiss = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => onDismiss?.(), 300);
  }, [onDismiss]);

  useEffect(() => {
    if (autoDismiss) {
      const timer = setTimeout(handleDismiss, autoDismiss);
      return () => clearTimeout(timer);
    }
  }, [autoDismiss, handleDismiss]);

  return (
    <AlertContainer
      $type={type}
      $dismissible={dismissible}
      $isClosing={isClosing}
      className={className}
      role="alert"
    >
      {children}
      {dismissible && (
        <DismissButton 
          onClick={handleDismiss} 
          aria-label="Dismiss alert"
        >
          <HiX /> 
        </DismissButton>
      )}
    </AlertContainer>
  );
};